import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appDisableMouseWheel]',
})
export class DisableMouseWheelDirective {
  @HostListener('mousewheel', ['$event']) onMouseWheelChrome(event: any) {
    this.mouseWheelFunc(event);
  }

  @HostListener('DOMMouseScroll', ['$event']) onMouseWheelFirefox(event: any) {
    this.mouseWheelFunc(event);
  }

  @HostListener('onmousewheel', ['$event']) onMouseWheelIE(event: any) {
    this.mouseWheelFunc(event);
  }

  constructor() {}

  mouseWheelFunc(event: any) {
    console.log('[mouseWheelFunc]');
    var event = window.event || event; // old IE support
    // for IE
    event.returnValue = false;
    // for Chrome and Firefox
    if (event.preventDefault) {
      event.preventDefault();
    }
  }
}
